import { useSelector } from 'react-redux';
import React, { useMemo } from 'react';
import { useLang } from '../../../util/lang';
import { Typography } from '@material-ui/core';

const useDraftComment = ({ currentPlanId, planRequest = null, planComment = null }) => {
    const { draftComment } = useSelector((state) => state.clinicalSimulation);
    const getLang = useLang();

    // Request text value would need to handle no plan id case
    const draftRequestValue = useMemo(() => {
        if (!draftComment) return planRequest || '';
        if (!currentPlanId) {
            return draftComment['NO_PLAN_ID']?.request || planRequest || '';
        }
        return draftComment[currentPlanId]?.request || planRequest || '';
    }, [draftComment, currentPlanId, planRequest]);

    const isRequestUnsaved = useMemo(() => {
        if (!draftComment) return false;
        const compareValue = planRequest || '';
        if (!currentPlanId) {
            if (!draftComment['NO_PLAN_ID']) return false;
            return draftComment['NO_PLAN_ID']?.request !== compareValue;
        }
        return draftRequestValue !== compareValue;
    }, [draftRequestValue, currentPlanId, planRequest]);

    // Comment must be after plan upload, the plan id must exist
    const draftCommentValue = useMemo(() => {
        const ogComment = planComment || '';
        return draftComment[currentPlanId]?.comment || ogComment;
    }, [draftComment, currentPlanId, planComment]);

    const isCommentUnsaved = useMemo(() => {
        if (!draftCommentValue || !draftCommentValue?.length) return false;
        return draftCommentValue !== planComment;
    }, [draftCommentValue, planComment]);

    const getMessageLabel = (label = '', isUnsaved = false) => {
        if (!isUnsaved) return label;
        return (
            <>
                {label} <Typography component="span" style={{ color: 'red' }}>{` (${getLang('@TreatmentPlanHistory.unsubmitted')})`}</Typography>
            </>
        );
    };

    return { draftRequestValue, isRequestUnsaved, draftCommentValue, isCommentUnsaved, getMessageLabel };
};

export default useDraftComment;
